import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=6bdb6ea1&scoped=true&"
import script from "./DataSummary.vue?vue&type=script&lang=js&"
export * from "./DataSummary.vue?vue&type=script&lang=js&"
import style0 from "./DataSummary.vue?vue&type=style&index=0&id=6bdb6ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb6ea1",
  null
  
)

export default component.exports